const relationships = [
	{ value: 'PARENT', label: 'Parent' },
	{ value: 'GUARDIAN', label: 'Guardian' },
	{ value: 'SIBLING', label: 'Sibling' },
	{ value: 'FRIEND', label: 'Friend' },
	{ value: 'PARTNER_SIGNIFICANT_OTHER', label: 'Partner / Significant other' },
	{ value: 'METAMOUR', label: 'Metamour' },
	{ value: 'CHILD', label: 'Child' },
	{ value: 'GRANDPARENT', label: 'Grandparent' },
	{ value: 'CAREGIVER', label: 'Caregiver' },
	{ value: 'OTHER', label: 'Other' },
];

export default relationships;
